import * as yup from 'yup'

export const tabFilterFormSchema = yup.object().shape({
  subsegment: yup.object(),
  status: yup.string()
})
